import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=3bb9df0b&name=main-image&"
import script from "./MainImage.vue?vue&type=script&lang=js&"
export * from "./MainImage.vue?vue&type=script&lang=js&"
import style0 from "./MainImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports